<div class="main-content">
    <div class="card">
        <p-toolbar styleClass="p-mb-4">
            <ng-template pTemplate="left">
                 <span class="p-input-icon-left">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" [(ngModel)]="nameToSearch" (keyup)="filterThrottle.next($event)" />
                </span>
            </ng-template>
            <ng-template pTemplate="right">
                <button pButton pRipple label="{{ 'CLIENT.ADD_NEW' | translate }}" icon="pi pi-plus"
                        class="p-button-success mr-2 njoyButton"
                        (click)="openNew()"></button>
            </ng-template>
        </p-toolbar>
        <p-table #dt [value]="users" [rows]="10" [paginator]="true" [rowHover]="true"
                 [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,25,50]">
            <ng-template pTemplate="header">
                <tr>
                    <th pSortableColumn="lastName">{{ 'CLIENT.LASTNAME_LABEL' | translate }}
                        <p-sortIcon field="lastName"></p-sortIcon>
                    </th>
                    <th>{{ 'CLIENT.FIRSTNAME_LABEL' | translate }}</th>
                    <th>{{ 'CLIENT.INSCRIPTION_DATE_LABEL' | translate }}</th>
                    <th>{{ 'CLIENT.SCAN_NUMBER_LABEL' | translate }}</th>
                    <th>{{ 'CLIENT.SUBSCRIPTION_OR_NOT_LABEL' | translate }}</th>
                    <th></th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-user>
                <tr (click)="openUpdateModal(user)">
                    <td>{{user?.lastName}}</td>
                    <td>{{user?.firstName}}</td>
                    <td>{{user?.creationDate | date: 'dd/MM/yyyy'}}</td>
                    <td>{{user?.scanNumber}}</td>
                    <td>
                        <div *ngIf="user.subscribed; then thenBlock else elseBlock"></div>
                        <ng-template #thenBlock>{{ 'CLIENT.SUBSCRIBED_LABEL' | translate }}</ng-template>
                        <ng-template #elseBlock>{{ 'CLIENT.INSCRIT_LABEL' | translate }}</ng-template>
                    </td>
                    <td (click)="$event.stopPropagation();"><a
                            href="/customers/{{user.uuid}}">{{ 'COMMON.DETAILS' | translate }}</a></td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>
<p-dialog *ngIf="addNewClientDialog" [(visible)]="addNewClientDialog" [style]="{width: '450px'}"
          [header]="modalTitle" [modal]="true"
          styleClass="p-fluid">

    <div class="container-fluid">
        <form [formGroup]="clientForm">
            <div class="row">
                <div class="col-md-12">
                    <mat-label>{{ 'CLIENT.LASTNAME_LABEL' | translate }} *</mat-label>
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="lastName"
                               [errorStateMatcher]="matcher" type="text">
                        <mat-error *ngIf="getControl?.lastName?.errors?.required">
                            {{ 'CLIENT.LASTNAME_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-label>{{ 'CLIENT.FIRSTNAME_LABEL' | translate }} *</mat-label>
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="firstName"
                               [errorStateMatcher]="matcher" type="text">
                        <mat-error *ngIf="getControl?.firstName?.errors?.required">
                            {{ 'CLIENT.FIRSTNAME_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-label>{{ 'CLIENT.EMAIL_LABEL' | translate }} *</mat-label>
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="email" [errorStateMatcher]="matcher"
                               type="text">
                        <mat-error
                                *ngIf="getControl?.email?.errors?.email">
                            {{ 'CLIENT.EMAIL_FORMAT_ERROR_LABEL' | translate }}
                        </mat-error>
                        <mat-error *ngIf="getControl?.email?.errors?.required">
                            {{ 'CLIENT.EMAIL_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                        </mat-error>
                    </mat-form-field>
                    <mat-error style="font-size: 75%;" *ngIf="usedEmail">
                        {{errorMessage}}
                    </mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-label>{{ 'CLIENT.PHONE_NUMBER' | translate }} *</mat-label>
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="phoneNumber"
                               [errorStateMatcher]="matcher" type="text">
                        <mat-error *ngIf="getControl?.phoneNumber?.errors?.required">
                            {{ 'CLIENT.PHONE_NUMBER_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_MALE' | translate }}</strong>
                        </mat-error>
                        <mat-error *ngIf="getControl?.phoneNumber?.errors?.pattern">
                            {{ 'CLIENT.PHONE_NUMBER_FORMAT_ERROR_LABEL' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-error style="font-size: 75%;" *ngIf="usedPhoneNumber">
                        {{errorMessage}}
                    </mat-error>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-label>{{ 'CLIENT.BIRTH_DATE_LABEL' | translate }} *</mat-label>
                    <mat-form-field class="example-full-width">
                        <input matInput [matDatepicker]="addNewCleintBirthDatePicker" formControlName="birthDate"
                               [errorStateMatcher]="matcher">
                        <mat-datepicker-toggle matSuffix
                                               [for]="addNewCleintBirthDatePicker"></mat-datepicker-toggle>
                        <mat-datepicker #addNewCleintBirthDatePicker></mat-datepicker>
                        <mat-error *ngIf="getControl?.birthDate?.errors?.required">
                            {{ 'CLIENT.BIRTH_DATE_REQUIRED_ERROR_LABEL' | translate }}
                            <strong>{{ 'COMMON.REQUIRED_FEMALE' | translate }}</strong>
                        </mat-error>
                        <mat-error *ngIf="getControl?.birthDate?.errors?.ageValidator">
                            {{ 'CLIENT.AGE_MINIMAL_ERROR_LABEL' | translate }}
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <div class="row">
            <div class="col-md-3 ml-5">
                <div class="example-full-width">
                    <i (click)="setGender('male')" class="fa fa-male" [style.border]="isMale? 'black solid 1px':''"></i>
                </div>
            </div>
            <div class="col-md-3 mr-3">
                <div class="example-full-width">
                    <i (click)="setGender('other')" class="fa fa-transgender"
                       [style.border]="isOther? 'black solid 1px':''"></i>
                </div>
            </div>
            <div class="col-md-3">
                <div class="example-full-width">
                    <i (click)="setGender('female')" class="fa fa-female"
                       [style.border]="isFemale? 'black solid 1px':''"></i>
                </div>
            </div>
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple label="{{ 'BUTTONS.SAVE' | translate }}" icon="pi pi-check" class="p-button-text"
                (click)="addOrUpdateClient()"></button>
    </ng-template>
</p-dialog>
<p-toast></p-toast>
